// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddMultipleEbooks_container__LRGU2 {
    padding: 2rem;
    max-width: 900px;
    margin: 0 auto;
    background-color: #111;
    color: #eee;
    min-height: 100vh;
  }
  
  .AddMultipleEbooks_title__YlWwK {
    margin-bottom: 2rem;
    text-align: center;
    font-size: 2.5rem;
    color: #ff3333;
    text-shadow: 0 0 10px rgba(255, 51, 51, 0.3);
  }
  
  .AddMultipleEbooks_form__xf4kT {
    background-color: #1a1a1a;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 4px 15px rgba(255, 51, 51, 0.2);
    border: 1px solid #333;
  }
  
  .AddMultipleEbooks_formGroup__8H\\+Ky {
    margin-bottom: 1.5rem;
  }
  
  .AddMultipleEbooks_formGroup__8H\\+Ky label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #ff6666;
  }
  
  .AddMultipleEbooks_input__wWpUb, .AddMultipleEbooks_select__lS2MW, .AddMultipleEbooks_textarea__Ee8gQ, .AddMultipleEbooks_contentTextarea__BGqA0 {
    width: 100%;
    padding: 0.75rem 0px;
    border: 1px solid #333;
    border-radius: 4px;
    font-size: 1rem;
    background-color: #222;
    color: #eee;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  .AddMultipleEbooks_input__wWpUb:focus, .AddMultipleEbooks_select__lS2MW:focus, .AddMultipleEbooks_textarea__Ee8gQ:focus, .AddMultipleEbooks_contentTextarea__BGqA0:focus {
    border-color: #ff3333;
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 51, 51, 0.2);
  }
  
  .AddMultipleEbooks_textarea__Ee8gQ {
    min-height: 100px;
    resize: vertical;
  }
  
  .AddMultipleEbooks_contentTextarea__BGqA0 {
    min-height: 300px;
    resize: vertical;
    font-family: monospace;
    line-height: 1.5;
  }
  
  .AddMultipleEbooks_fileInput__99x\\+N {
    width: 100%;
    padding: 0.5rem 0;
    color: #eee;
  }
  
  .AddMultipleEbooks_fileInput__99x\\+N::file-selector-button {
    background-color: #333;
    color: #eee;
    border: 1px solid #444;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 1rem;
    transition: background-color 0.2s;
  }
  
  .AddMultipleEbooks_fileInput__99x\\+N::file-selector-button:hover {
    background-color: #444;
  }
  
  .AddMultipleEbooks_checkboxLabel__1ibad {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .AddMultipleEbooks_checkbox__B7Baw {
    margin-right: 0.5rem;
    cursor: pointer;
    width: 16px;
    height: 16px;
    accent-color: #ff3333;
  }
  
  .AddMultipleEbooks_imageUploadContainer__MKxIM {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  
  .AddMultipleEbooks_imageUpload__j\\+Tnn {
    display: flex;
    flex-direction: column;
  }
  
  .AddMultipleEbooks_imagePreview__i\\+A7o {
    margin-top: 0.5rem;
    padding: 0.5rem;
    background-color: #333;
    border-radius: 4px;
    font-size: 0.875rem;
  }
  
  .AddMultipleEbooks_chaptersSection__Fpscg {
    margin-top: 2.5rem;
    border-top: 1px solid #333;
    padding-top: 1.5rem;
  }
  
  .AddMultipleEbooks_chaptersSectionHeader__ua-EI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .AddMultipleEbooks_chaptersSectionHeader__ua-EI h3 {
    color: #ff3333;
    font-size: 1.5rem;
    margin: 0;
  }
  
  .AddMultipleEbooks_addChapterButton__nMPNr {
    background-color: #333;
    color: #eee;
    border: 1px solid #444;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s, color 0.2s;
  }
  
  .AddMultipleEbooks_addChapterButton__nMPNr:hover {
    background-color: #ff3333;
    color: #fff;
    border-color: #ff3333;
  }
  
  .AddMultipleEbooks_chapterItem__s1L2l {
    background-color: #222;
    border-radius: 6px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid #ff3333;
  }
  
  .AddMultipleEbooks_chapterHeader__hr78z {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .AddMultipleEbooks_chapterHeader__hr78z h4 {
    margin: 0;
    color: #ff6666;
    font-size: 1.25rem;
  }
  
  .AddMultipleEbooks_removeChapterButton__aKsat {
    background-color: transparent;
    color: #ff6666;
    border: 1px solid #ff6666;
    border-radius: 4px;
    padding: 0.25rem 0.75rem;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
  }
  
  .AddMultipleEbooks_removeChapterButton__aKsat:hover {
    background-color: #ff3333;
    color: #fff;
    border-color: #ff3333;
  }
  
  .AddMultipleEbooks_formAction__m9AFM {
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
  }
  
  .AddMultipleEbooks_submitButton__SLyr8 {
    background-color: #ff3333;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1.125rem;
    font-weight: 500;
    padding: 0.75rem 2.5rem;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
    box-shadow: 0 4px 8px rgba(255, 51, 51, 0.3);
  }
  
  .AddMultipleEbooks_submitButton__SLyr8:hover {
    background-color: #ff4444;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 51, 51, 0.4);
  }
  
  .AddMultipleEbooks_submitButton__SLyr8:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(255, 51, 51, 0.3);
  }
  
  .AddMultipleEbooks_submitButton__SLyr8:disabled {
    background-color: #666;
    transform: none;
    box-shadow: none;
    cursor: not-allowed;
  }
  
  .AddMultipleEbooks_message__vh23W {
    padding: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 4px;
    font-weight: 500;
  }
  
  .AddMultipleEbooks_success__A3aH9 {
    background-color: #12372A;
    color: #4ECCA3;
    border: 1px solid #4ECCA3;
  }
  
  .AddMultipleEbooks_error__75Tl4 {
    background-color: #2B1B17;
    color: #FF6B6B;
    border: 1px solid #FF6B6B;
  }
  .AddMultipleEbooks_previewImageContainer__tjZTI {
    margin-top: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    background-color: #f9f9f9;
    max-width: 300px;
  }
  
  .AddMultipleEbooks_previewImage__8EsTw {
    width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    border-radius: 3px;
    display: block;
  }
  
  .AddMultipleEbooks_imagePreview__i\\+A7o {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
  }
  
  .AddMultipleEbooks_imageUpload__j\\+Tnn {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    margin-right: 15px;
  }
  
  .AddMultipleEbooks_imageUpload__j\\+Tnn:last-child {
    margin-right: 0;
  }
  
  .AddMultipleEbooks_imageUploadContainer__MKxIM {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
  .AddMultipleEbooks_removeImageButton__FsnpY {
    position: absolute;
    top: 4px;
    right: 4px;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    z-index: 2;
  }
  
  .AddMultipleEbooks_previewImageContainer__tjZTI {
    position: relative;
    display: inline-block;
  }
  .AddMultipleEbooks_seriesImagePreview__ByFRB {
    margin-top: 10px;
    text-align: center;
  }
  
  .AddMultipleEbooks_seriesImageLabel__XKRMm {
    font-weight: 600;
    margin-bottom: 4px;
  }
  
  .AddMultipleEbooks_seriesImage__hbi\\+J {
    max-width: 200px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  }
  
  
  @media (max-width: 768px) {
    .AddMultipleEbooks_imageUploadContainer__MKxIM {
      flex-direction: column;
    }
    
    .AddMultipleEbooks_imageUpload__j\\+Tnn {
      margin-right: 0;
      margin-bottom: 15px;
    }
  }
  
  @media (max-width: 768px) {
    .AddMultipleEbooks_container__LRGU2 {
      padding: 1rem;
    }
    
    .AddMultipleEbooks_form__xf4kT {
      padding: 1.5rem;
    }
    
    .AddMultipleEbooks_imageUploadContainer__MKxIM {
      grid-template-columns: 1fr;
    }
    
    .AddMultipleEbooks_chaptersSectionHeader__ua-EI {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
    
    .AddMultipleEbooks_addChapterButton__nMPNr {
      width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/multiple-content/AddMultipleEbooks.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,6CAA6C;IAC7C,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,8CAA8C;EAChD;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iDAAiD;IACjD,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;EACxC;;;EAGA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":[".container {\n    padding: 2rem;\n    max-width: 900px;\n    margin: 0 auto;\n    background-color: #111;\n    color: #eee;\n    min-height: 100vh;\n  }\n  \n  .title {\n    margin-bottom: 2rem;\n    text-align: center;\n    font-size: 2.5rem;\n    color: #ff3333;\n    text-shadow: 0 0 10px rgba(255, 51, 51, 0.3);\n  }\n  \n  .form {\n    background-color: #1a1a1a;\n    border-radius: 8px;\n    padding: 2rem;\n    box-shadow: 0 4px 15px rgba(255, 51, 51, 0.2);\n    border: 1px solid #333;\n  }\n  \n  .formGroup {\n    margin-bottom: 1.5rem;\n  }\n  \n  .formGroup label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    color: #ff6666;\n  }\n  \n  .input, .select, .textarea, .contentTextarea {\n    width: 100%;\n    padding: 0.75rem 0px;\n    border: 1px solid #333;\n    border-radius: 4px;\n    font-size: 1rem;\n    background-color: #222;\n    color: #eee;\n    transition: border-color 0.2s, box-shadow 0.2s;\n  }\n  \n  .input:focus, .select:focus, .textarea:focus, .contentTextarea:focus {\n    border-color: #ff3333;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(255, 51, 51, 0.2);\n  }\n  \n  .textarea {\n    min-height: 100px;\n    resize: vertical;\n  }\n  \n  .contentTextarea {\n    min-height: 300px;\n    resize: vertical;\n    font-family: monospace;\n    line-height: 1.5;\n  }\n  \n  .fileInput {\n    width: 100%;\n    padding: 0.5rem 0;\n    color: #eee;\n  }\n  \n  .fileInput::file-selector-button {\n    background-color: #333;\n    color: #eee;\n    border: 1px solid #444;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-right: 1rem;\n    transition: background-color 0.2s;\n  }\n  \n  .fileInput::file-selector-button:hover {\n    background-color: #444;\n  }\n  \n  .checkboxLabel {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n  \n  .checkbox {\n    margin-right: 0.5rem;\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n    accent-color: #ff3333;\n  }\n  \n  .imageUploadContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n  \n  .imageUpload {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .imagePreview {\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    background-color: #333;\n    border-radius: 4px;\n    font-size: 0.875rem;\n  }\n  \n  .chaptersSection {\n    margin-top: 2.5rem;\n    border-top: 1px solid #333;\n    padding-top: 1.5rem;\n  }\n  \n  .chaptersSectionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .chaptersSectionHeader h3 {\n    color: #ff3333;\n    font-size: 1.5rem;\n    margin: 0;\n  }\n  \n  .addChapterButton {\n    background-color: #333;\n    color: #eee;\n    border: 1px solid #444;\n    border-radius: 4px;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.2s, color 0.2s;\n  }\n  \n  .addChapterButton:hover {\n    background-color: #ff3333;\n    color: #fff;\n    border-color: #ff3333;\n  }\n  \n  .chapterItem {\n    background-color: #222;\n    border-radius: 6px;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    border-left: 4px solid #ff3333;\n  }\n  \n  .chapterHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .chapterHeader h4 {\n    margin: 0;\n    color: #ff6666;\n    font-size: 1.25rem;\n  }\n  \n  .removeChapterButton {\n    background-color: transparent;\n    color: #ff6666;\n    border: 1px solid #ff6666;\n    border-radius: 4px;\n    padding: 0.25rem 0.75rem;\n    cursor: pointer;\n    transition: background-color 0.2s, color 0.2s;\n  }\n  \n  .removeChapterButton:hover {\n    background-color: #ff3333;\n    color: #fff;\n    border-color: #ff3333;\n  }\n  \n  .formAction {\n    margin-top: 2.5rem;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .submitButton {\n    background-color: #ff3333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 1.125rem;\n    font-weight: 500;\n    padding: 0.75rem 2.5rem;\n    cursor: pointer;\n    transition: background-color 0.2s, transform 0.1s;\n    box-shadow: 0 4px 8px rgba(255, 51, 51, 0.3);\n  }\n  \n  .submitButton:hover {\n    background-color: #ff4444;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(255, 51, 51, 0.4);\n  }\n  \n  .submitButton:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(255, 51, 51, 0.3);\n  }\n  \n  .submitButton:disabled {\n    background-color: #666;\n    transform: none;\n    box-shadow: none;\n    cursor: not-allowed;\n  }\n  \n  .message {\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n    border-radius: 4px;\n    font-weight: 500;\n  }\n  \n  .success {\n    background-color: #12372A;\n    color: #4ECCA3;\n    border: 1px solid #4ECCA3;\n  }\n  \n  .error {\n    background-color: #2B1B17;\n    color: #FF6B6B;\n    border: 1px solid #FF6B6B;\n  }\n  .previewImageContainer {\n    margin-top: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 5px;\n    background-color: #f9f9f9;\n    max-width: 300px;\n  }\n  \n  .previewImage {\n    width: 100%;\n    height: auto;\n    max-height: 200px;\n    object-fit: contain;\n    border-radius: 3px;\n    display: block;\n  }\n  \n  .imagePreview {\n    display: flex;\n    flex-direction: column;\n    margin-top: 8px;\n  }\n  \n  .imageUpload {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin-right: 15px;\n  }\n  \n  .imageUpload:last-child {\n    margin-right: 0;\n  }\n  \n  .imageUploadContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  .removeImageButton {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    z-index: 2;\n  }\n  \n  .previewImageContainer {\n    position: relative;\n    display: inline-block;\n  }\n  .seriesImagePreview {\n    margin-top: 10px;\n    text-align: center;\n  }\n  \n  .seriesImageLabel {\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n  \n  .seriesImage {\n    max-width: 200px;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  }\n  \n  \n  @media (max-width: 768px) {\n    .imageUploadContainer {\n      flex-direction: column;\n    }\n    \n    .imageUpload {\n      margin-right: 0;\n      margin-bottom: 15px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 1rem;\n    }\n    \n    .form {\n      padding: 1.5rem;\n    }\n    \n    .imageUploadContainer {\n      grid-template-columns: 1fr;\n    }\n    \n    .chaptersSectionHeader {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 1rem;\n    }\n    \n    .addChapterButton {\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddMultipleEbooks_container__LRGU2`,
	"title": `AddMultipleEbooks_title__YlWwK`,
	"form": `AddMultipleEbooks_form__xf4kT`,
	"formGroup": `AddMultipleEbooks_formGroup__8H+Ky`,
	"input": `AddMultipleEbooks_input__wWpUb`,
	"select": `AddMultipleEbooks_select__lS2MW`,
	"textarea": `AddMultipleEbooks_textarea__Ee8gQ`,
	"contentTextarea": `AddMultipleEbooks_contentTextarea__BGqA0`,
	"fileInput": `AddMultipleEbooks_fileInput__99x+N`,
	"checkboxLabel": `AddMultipleEbooks_checkboxLabel__1ibad`,
	"checkbox": `AddMultipleEbooks_checkbox__B7Baw`,
	"imageUploadContainer": `AddMultipleEbooks_imageUploadContainer__MKxIM`,
	"imageUpload": `AddMultipleEbooks_imageUpload__j+Tnn`,
	"imagePreview": `AddMultipleEbooks_imagePreview__i+A7o`,
	"chaptersSection": `AddMultipleEbooks_chaptersSection__Fpscg`,
	"chaptersSectionHeader": `AddMultipleEbooks_chaptersSectionHeader__ua-EI`,
	"addChapterButton": `AddMultipleEbooks_addChapterButton__nMPNr`,
	"chapterItem": `AddMultipleEbooks_chapterItem__s1L2l`,
	"chapterHeader": `AddMultipleEbooks_chapterHeader__hr78z`,
	"removeChapterButton": `AddMultipleEbooks_removeChapterButton__aKsat`,
	"formAction": `AddMultipleEbooks_formAction__m9AFM`,
	"submitButton": `AddMultipleEbooks_submitButton__SLyr8`,
	"message": `AddMultipleEbooks_message__vh23W`,
	"success": `AddMultipleEbooks_success__A3aH9`,
	"error": `AddMultipleEbooks_error__75Tl4`,
	"previewImageContainer": `AddMultipleEbooks_previewImageContainer__tjZTI`,
	"previewImage": `AddMultipleEbooks_previewImage__8EsTw`,
	"removeImageButton": `AddMultipleEbooks_removeImageButton__FsnpY`,
	"seriesImagePreview": `AddMultipleEbooks_seriesImagePreview__ByFRB`,
	"seriesImageLabel": `AddMultipleEbooks_seriesImageLabel__XKRMm`,
	"seriesImage": `AddMultipleEbooks_seriesImage__hbi+J`
};
export default ___CSS_LOADER_EXPORT___;
